module.exports = __webpack_public_path__ + "static/media/andrews_blogo.70ef671d.png";